import service from "./service";
import {FeatureNameEnum} from '../featureManager/helper';
import OnBoardTutorialController from "../../features/onBoardTutorial/controller";

import KinematicsController from '../kinematics/controller';

let AnnotationController = new function () {
    let self = this;

    self.registerFeature = function (feature) {
        self.feature = feature;
    };

    self.menuState = {
        AnnotationEnabled: false,
        AnnotationShowComp: false,
        AnnotationDelete: false,
        AnnotationChangeText: false,
        AnnotationVisibility: true,
        AnnotationSeeThrough: true
    };

    self.initMenu = function (parentMenuController, prop, isPresenter) {
        const addEvents = () => {
            document.addEventListener('annotation.enabled', function () {
                let itemStatus = get2dMenuItemStatus('Annotation');
                self.menuCallback.activeStatusChanged(!itemStatus);
            });
            document.addEventListener('annotation.visibility', function () {
                self.menuCallback.visibilityChanged(!self.menuState.AnnotationVisibility);
            });
            document.addEventListener('annotation.showComponents', function () {
                self.menuCallback.detailLevelChanged(!self.menuState.AnnotationShowComp);
            });
            document.addEventListener('annotation.changeText', function () {
                self.menuCallback.changeTextStatusChanged(!self.menuState.AnnotationChangeText);
            });
            document.addEventListener('annotation.deleteEnabled', function () {
                self.menuCallback.deleteStatusChanged(!self.menuState.AnnotationDelete);
            });
            document.addEventListener('annotation.deleteMyAnnotation', function () {
                self.menuCallback.deleteMyAnnotation();
            });
        };
        if (!self.menuItem) {
            const maxItemInRow = prop.maxItemInRow ? prop.maxItemInRow : 3;
            self.menuItem = new MenuData(AnnotationMenu.text, maxItemInRow, 5);
            self.menuController = new MenuController(self.menuItem);
            self.menuController.setMenuControlParameter(VR.scene, iq3Camera.camera, wv.selectionSphere);
            self.menuItem.hasMainMenuItem = true;
            parseChildrenItems(self.menuController, prop.children, menuItemMaps.annotationMenuItemMap);

           addEvents();
        }

        self.menuItem.isVisible = prop.isVisible;
        self.menuItem.isPresenter = prop.isPresenter;
        self.menuItem.isViewer = prop.isViewer;
        parentMenuController.appendMenuItem(AnnotationMenu.menuItemName, prop.text || AnnotationMenu.text, self.menuItem);
    };

    self.getAllAnnotationsAddedModelIds = function () {
        return self.feature.getAllAnnotationsAddedModelIds();
    };

    self.isAnnotationOnHelperObject = function (annotationId) {
        return self.feature.isAnnotationOnHelperObject(annotationId);
    };

    self.menuCallback = {
        activeStatusChanged: function (value) {
            if (KinematicsController.active) {
                return false;
            }

            wv.selectionSphere.RegisterShow(self.menuController, value);
            self.menuState.AnnotationEnabled = value;
            checkBoxSyncVR(annotationFeature.menuItemName, value);

            self.menuCallback._handleFeatureStack(
                self.inputDeviceCallback.mouseClickForAdd,
                self.inputDeviceCallback.controllerPressedForAdd,
                self.menuCallback.activeStatusChanged,
                annotationFeature.menuItemName,
                value,
                !value
            );

            if (value) {
                self.menuCallback.visibilityChanged(true);
            }
        },

        deleteStatusChanged: function (value) {
            self.menuState.AnnotationDelete = value;
            checkBoxSyncVR(deleteAnnotationFeature.menuItemName, value);

            self.menuCallback._handleFeatureStack(
                self.inputDeviceCallback.mouseClickForRemovingAnnotation,
                self.inputDeviceCallback.controllerClickForRemovingAnnotation,
                self.menuCallback.deleteStatusChanged,
                deleteAnnotationFeature.menuItemName,
                value,
                !value
            );

            if (value) {
                self.menuCallback.visibilityChanged(true);
                self.menuCallback.changeTextStatusChanged(false);
            }

            GPUPicker.flags.pickTooltip = value;
        },

        changeTextStatusChanged: function (value) {
            self.menuState.AnnotationChangeText = value;
            checkBoxSyncVR(changeAnnotationFeature.menuItemName, value);

            self.menuCallback._handleFeatureStack(
                self.inputDeviceCallback.mouseClickForChangingAnnotation,
                self.inputDeviceCallback.controllerClickForChangingAnnotation,
                self.menuCallback.changeTextStatusChanged,
                changeAnnotationFeature.menuItemName,
                value,
                !value
            );

            if (value) {
                self.menuCallback.visibilityChanged(true);
                self.menuCallback.deleteStatusChanged(false);
            }

            GPUPicker.flags.pickTooltip = value;
        },

        _handleFeatureStack: function (mouseCallback, controllerCallback, menuCallback, title, isActivating, disabledState) {
            manageFeatureAndCallbackHandler(wv.mouseClickCallbackHandler, {callback: mouseCallback}, isActivating,
                title, menuCallback, disabledState, false, undefined, undefined);
            manageFeatureAndCallbackHandler(wv.controllerTriggerDownCallbackhandler,
                {
                    callback: controllerCallback,
                    animateFunction: playPointStartAnimationForThisController,
                    reverseCallbackHandler: wv.controllerTriggerReleasedCallbackhandler,
                    reverseAnimateFunction: playPointEndAnimationForThisController
                }, isActivating, title, menuCallback, disabledState, false, undefined, {toolbarEvent: 'annotation.updateCallbackHandler'});
        },

        visibilityChanged: function (value) {
            if (is_current_user_presenter()) {
                service.setVisibility(value);
            } else {
                self.serverMessageHandler.setVisibility(value);
            }
        },

        detailLevelChanged: function (value) {
            self.menuState.AnnotationShowComp = value;
            checkBoxSyncVR("AnnotationChk", value);
            self.feature.setShowDetails(value);

            if (value) {
                self.menuCallback.visibilityChanged(true);
            }
        },

        deleteMyAnnotation: function () {
            service.deleteByAuthor(wv.registeredID);
            undoManager.clear();
        },

        deleteAllAnnotation: function () {
            service.deleteAll();
            undoManager.clear();
        },

        processAnnotationSeeThrough: function (seeThrough) {
            wv.sendTextMessage(text_updateFeatureSeeThroughStatus, FeatureNameEnum.ANNOTATION, seeThrough ? "1" : "0");
        }
    };

    self.inputDeviceCallback = {
        mouseClickForRemovingAnnotation: function (mouseEvent) {
            return self.inputDeviceCallback.remove(mouseEvent, true);
        },

        controllerClickForRemovingAnnotation: function (controllerEvent) {
            return self.inputDeviceCallback.remove(controllerEvent, false);
        },

        mouseClickForChangingAnnotation: function (mouseEvent) {
            return self.inputDeviceCallback.changeText(mouseEvent, true);
        },

        controllerClickForChangingAnnotation: function (controllerEvent) {
            return self.inputDeviceCallback.changeText(controllerEvent, false);
        },

        mouseClickForAdd: function (mouseEvent) {
            let volumeData = mouseEvent.pickingData;
            return self.inputDeviceCallback._handleAdd(volumeData.meshType, volumeData.volume, volumeData.point, volumeData.normal);
        },

        controllerPressedForAdd: function (controller) {
            let volumeData = controller.pickingData;
            return self.inputDeviceCallback._handleAdd(volumeData.meshType, volumeData.volume, volumeData.point, volumeData.normal);
        },

        _handleAdd: function (meshType, volume, point, normal) {
            if (meshType === MeshTypeEnum.CAD || meshType === MeshTypeEnum.POINT_CLOUD) {
                const modelId = volume.modelId;
                let model = getModelObject(modelId);

                if (meshType === MeshTypeEnum.POINT_CLOUD) {
                    normal = iq3Camera.getConfigurationWorld().position.clone().sub(point).normalize();
                }

                let originalPoint = getOrgPosition(model.worldToLocal(point.clone()), modelId, volume.branchID);
                let originalNormal = getOrgPosition(model.worldToLocal(point.clone().add(normal)), modelId, volume.branchID).sub(originalPoint).normalize();

                let keyboardCallbacks = {};
                keyboardCallbacks.enterCallback = function (text) {
                    mController.loadAndResetSavedMenuState();
                    if (!self.menuState.AnnotationEnabled) {
                        return;
                    }

                    if (!text.trim().length) {
                        return true;
                    }

                    let uniqueId = generateUUID();

                    handleOperation(() => {
                        service.add({
                            id: uniqueId,
                            location: {
                                modelId,
                                branchId: volume.branchID,
                                position: originalPoint,
                                normal: originalNormal
                            },
                            info: {
                                authorId: wv.registeredID,
                                authorName: wv.effectController.registerMap[wv.registeredID],
                                text
                            }
                        });
                    }, () => {
                        service.remove(wv.registeredID, uniqueId);
                    });
                };

                keyboardCallbacks.cancelCallback = function () {
                    mController.loadAndResetSavedMenuState();
                };

                keyboardController.toggleState(keyboardController.getVRKeyboardParent(), keyboardCallbacks);

                return true;
            }

            return false;
        },

        remove: function (event, isMouse = true) {
            let annotation = self.feature.pickAnnotation(event, isMouse);
            if (annotation) {
                handleOperation(() => {
                    service.remove(annotation.data.info.authorId, annotation.data.id);
                }, () => {
                    service.add(annotation.data);
                });
            }
        },

        changeText: function (event, isMouse = true) {
            let annotation = self.feature.pickAnnotation(event, isMouse);
            if (annotation) {
                let keyboardCallbacks = {};
                keyboardCallbacks.enterCallback = function (newText) {
                    mController.loadAndResetSavedMenuState();
                    let oldText = annotation.data.info.text;
                    if (newText.trim().length === 0) {
                        return;
                    }

                    handleOperation(() => {
                        service.changeText(annotation.data.info.authorId, annotation.data.id, newText);
                    }, () => {
                        service.changeText(annotation.data.info.authorId, annotation.data.id, oldText);
                    });
                };

                keyboardCallbacks.cancelCallback = function () {
                    mController.loadAndResetSavedMenuState();
                };

                keyboardController.toggleState(keyboardController.getVRKeyboardParent(), keyboardCallbacks, annotation.data.info.text);
            }
        },

        controllerRayUpdate: function (controller) {
            let intersects = raycast.intersectObjects(self.feature.object.children, true);
            let annotationObject = intersects.length && intersects[0].object;

            while (annotationObject && !annotationObject.annotationId) {
                annotationObject = annotationObject.parent;
            }

            update_controller_ray_length(controller, intersects[0] ? intersects[0] : null);
            return !!annotationObject;
        }
    };

    function handleOperation(operation, inverseOperation) {
        operation();
        undoManager.add({
            undo: inverseOperation,
            redo: operation
        });
    }

    self.serverMessageHandler = {
        setVisibility: function (value) {
            self.menuState.AnnotationVisibility = value;
            checkBoxSyncVR("annotationVisibility", value);

            self.feature.setVisibility(value);

            if (!value) {
                self.menuCallback.activeStatusChanged(false);
                self.menuCallback.deleteStatusChanged(false);
                self.menuCallback.changeTextStatusChanged(false);
            }
        },

        add: function (annotationData) {
            self.feature.add(annotationData);
        },

        remove: function (annotationId) {
            self.feature.remove(annotationId);
        },

        deleteByModel: function (modelId) {
            self.feature.deleteByModel(modelId);
        },

        deleteByAuthor: function (authorId, excludeHelperObjects = false) {
            self.feature.deleteByAuthor({ authorId, excludeHelperObjects });
        },

        deleteAll: function (excludeHelperObjects = false) {
            self.feature.deleteAll(excludeHelperObjects);
        },

        changeText: function (annotationId, newText) {
            self.feature.changeText({
                id: annotationId,
                text: newText
            });
        },

        setSeeThrough: function (seeThrough) {
            self.menuState.AnnotationSeeThrough = seeThrough;
            checkBoxSyncVR("AnnotationSeeThrough", seeThrough);

            self.feature.updateSeeThrough(seeThrough);
        }
    };

    self.saveState = function (document, rootObject, modelId = null) {
        const annotationsNode = document.createElement("annotations");
        annotationsNode.setAttribute("version", "1");
        annotationsNode.setAttribute("isSeeThroughEnabled", self.feature.getSeeThroughValue() ? "1" : "0");

        const annotationList = self.feature.getAllAnnotations().filter(obj => modelId === null || obj.location.modelId === modelId);

        for (const annotationObj of annotationList) {
            const userId = annotationObj.info.authorId;
            const name = annotationObj.id;
            const text = annotationObj.info.text;
            const bk_color = "default";

            const normalX = annotationObj.location.normal.x;
            const normalY = annotationObj.location.normal.y;
            const normalZ = annotationObj.location.normal.z;

            const basePointX = annotationObj.location.position.x;
            const basePointY = annotationObj.location.position.y;
            const basePointZ = annotationObj.location.position.z;

            const modelId = annotationObj.location.modelId;
            const branchId = annotationObj.location.branchId;
            const authorName = annotationObj.info.authorName;

            const annotation = document.createElement("annotation");
            annotation.setAttribute("userId", userId);
            annotation.setAttribute("name", name);
            annotation.setAttribute("text", text);
            annotation.setAttribute("bk_color", bk_color);
            annotation.setAttribute("normalX", normalX);
            annotation.setAttribute("normalY", normalY);
            annotation.setAttribute("normalZ", normalZ);
            annotation.setAttribute("basePointX", basePointX);
            annotation.setAttribute("basePointY", basePointY);
            annotation.setAttribute("basePointZ", basePointZ);
            annotation.setAttribute("modelId", modelId);
            annotation.setAttribute("branchId", branchId);
            annotation.setAttribute("authorName", authorName);

            annotationsNode.appendChild(annotation);
        }
        rootObject.appendChild(annotationsNode);
    };

    self.loadState = function (object) {
        if (!object.hasOwnProperty("annotations")) {
            return;
        }

        const annotations = object.annotations[0];
        const version = annotations.$.version;
        const isSeeThroughEnabled = annotations.$.isSeeThroughEnabled === "1";

        self.feature.updateSeeThrough(isSeeThroughEnabled);

        if (annotations.hasOwnProperty("annotation")) {
            for (const annotationXml of annotations.annotation) {
                const userId = annotationXml.$.userId;
                const name = annotationXml.$.name;
                const text = annotationXml.$.text;
                const bk_color = annotationXml.$.bk_color;

                const normalX = annotationXml.$.normalX;
                const normalY = annotationXml.$.normalY;
                const normalZ = annotationXml.$.normalZ;

                const basePointX = annotationXml.$.basePointX;
                const basePointY = annotationXml.$.basePointY;
                const basePointZ = annotationXml.$.basePointZ;

                const modelId = annotationXml.$.modelId;
                const branchId = annotationXml.$.branchId;
                const authorName = annotationXml.$.authorName;

                AnnotationController.serverMessageHandler.add({
                    id: name,
                    location: {
                        modelId: modelId,
                        branchId: branchId,
                        position: new THREE.Vector3(parseFloat(basePointX), parseFloat(basePointY), parseFloat(basePointZ)),
                        normal: new THREE.Vector3(parseFloat(normalX), parseFloat(normalY), parseFloat(normalZ)),
                    },
                    info: {
                        authorId: parseInt(userId),
                        authorName: authorName || "guest",
                        text: text
                    }
                });
            }
        }
    }
};

document.addEventListener('annotation.updateCallbackHandler', function (event) {
    menuViewToolbarController.setToolbarItemStatusById('Annotation', event.callbackValue);
});

VR.scene.addEventListener('volumeVisibility', ({meshName, visible}) => {
    window.stateStore.commit('garbage_can/TRIGGER_ALL_VOLUME_VISIBILITY_UPDATED_ON_MODEL', {
        modelId: meshName,
        visible: visible
    });
    window.stateStore.commit('garbage_can/TRIGGER_VOLUME_VISIBILITY_UPDATED', {branchId: meshName});
    handleVisibilityOfThisType(HANDLER_TYPE_ENUM.VOLUME_VISIBILITY, meshName, visible);
});

clipPlaneController.planeObject.addEventListener(clipPlaneController.eventListenerName, () => {
    const modelIds = AnnotationController.getAllAnnotationsAddedModelIds();
    modelIds.forEach(modelId => {
        let modelObject = getModelObject(modelId);
        if (modelObject.meshType === MeshTypeEnum.CAD) {
            window.stateStore.commit('garbage_can/TRIGGER_ALL_VOLUME_VISIBILITY_UPDATED_ON_MODEL', {modelId: modelId});
        }
    });

    /*
    As volume visibility update gets call from multiple places, sometimes vue rendering fails to properly update (annotation data)
    Hence, triggering camera position update for ensuring feature (annotation) matrix update
     */
    window.stateStore.commit('garbage_can/TRIGGER_CAMERA_POSITION_UPDATED');
});

pointCloudController.clipBoxController.volume.addEventListener('clipBoxChanged', () => {
    const modelIds = AnnotationController.getAllAnnotationsAddedModelIds();
    modelIds.forEach(modelId => {
        let modelObject = getModelObject(modelId);
        if (modelObject.meshType === MeshTypeEnum.POINT_CLOUD) {
            window.stateStore.commit('garbage_can/TRIGGER_ALL_VOLUME_VISIBILITY_UPDATED_ON_MODEL', {modelId: modelId});
        }
    });
});

export default AnnotationController
